import React from 'react';
import { Link } from 'react-router-dom';
import { formatFileSize } from '../../utils/fileUtils';
import { useAuth } from '../../context/AuthContext';
import { formatDate } from '../../utils/dateUtils';

const DocumentCard = ({ document, onRowClick, isSelected, onSelect }) => {
  const { user } = useAuth();

  return (
    <div 
      className={`bg-white rounded-lg shadow-md p-4 flex items-center space-x-4 ${isSelected ? 'ring-2 ring-indigo-500' : ''}`}
      onClick={() => onRowClick(document.id)}
    >
      <input
        type="checkbox"
        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
        checked={isSelected}
        onChange={() => onSelect(document.id)}
      />
      <div className="flex-grow">
        <p className="text-sm font-medium text-gray-900">{document.title}</p>
        <p className="text-sm text-gray-500">{document.type_name}</p>
      </div>
      <div className="text-right">
        <p className="text-sm text-gray-500">{document.file_size ? formatFileSize(document.file_size) : '0 B'}</p>
        <p className="text-sm text-gray-500">{formatDate(document.created_at, { user, includeTime: true })}</p>
      </div>
    </div>
  );
};

export default DocumentCard;
